import React from 'react';
import { FaTrash } from 'react-icons/fa6';
import './RoleCard.css';

const RoleCard = ({ role, onClick, onDelete }) => {
  const handleDelete = (e) => {
    e.stopPropagation();
    if (window.confirm(`Are you sure you want to delete "${role.roleName}"? This action cannot be undone.`)) {
      onDelete(role.roleId);
    }
  };

  const description = role.description || 'No description';
  const truncatedDescription = description.length > 100 
    ? description.substring(0, 100) + '...' 
    : description;

  return (
    <div className="role-card" onClick={onClick}>
      <div className="role-card-content">
        <div className="role-card-header">
          <h3 className="role-card-title">{role.roleName}</h3>
          <button
            className="role-card-delete-button"
            onClick={handleDelete}
            aria-label="Delete role"
          >
            <FaTrash className="delete-icon" />
          </button>
        </div>
        
        <p className="role-card-description">{truncatedDescription}</p>
        
        <div className="role-card-stats">
          <span className="role-card-stat">
            {role.responsibilityCount || 0} {role.responsibilityCount === 1 ? 'responsibility' : 'responsibilities'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RoleCard;
